import { render, staticRenderFns } from "./convenientMenu.vue?vue&type=template&id=00d89d1a&"
import script from "./convenientMenu.vue?vue&type=script&lang=js&"
export * from "./convenientMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/convenientMenu.vue"
export default component.exports